import Typeography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'src/constants/routes';
import { ComplianceTermItem } from './components/ComplianceTermItem';
import { complianceTermsContentData } from './data';
import {
  ComplianceTermsSectionBody,
  ComplianceTermsSectionContainer,
  ComplianceTermsSectionFooter,
  ComplianceTermsSectionHeader,
  ComplianceTermsSectionTitle,
  LegalCopyText,
  LinkPolicyButton,
} from './styles';
import Container from '../../components/Container';

export function ComplianceTerms() {
  const navigate = useNavigate();

  const onLinkPolicy = () => {
    navigate(ROUTES.COMPLIANCE_PROVIDERS_PATH);
  };

  return (
    <Container component={'section'}>
      <ComplianceTermsSectionContainer>
        <ComplianceTermsSectionHeader component={'header'}>
          <ComplianceTermsSectionTitle component={'h1'} variant="h3">
            Validate your renters insurance
          </ComplianceTermsSectionTitle>
          <Typeography variant={'body1'}>
            Link your policy to verify coverage.
          </Typeography>
        </ComplianceTermsSectionHeader>
        <ComplianceTermsSectionBody>
          {complianceTermsContentData.map((item) => (
            <ComplianceTermItem
              key={item.title}
              icon={item.icon}
              text={item.text}
              title={item.title}
            />
          ))}
        </ComplianceTermsSectionBody>
        <ComplianceTermsSectionFooter component={'footer'}>
          <LinkPolicyButton
            onClick={onLinkPolicy}
            type="button"
            role="link"
            variant="contained"
          >
            Link My Policy
          </LinkPolicyButton>
          <LegalCopyText>
            *Renters insurance is a requirement of your lease. Failure to comply
            could subject you to fines, fees, and responsibility for any damage
            caused to your apartment or building by you, your roommates, and/or
            guests.
          </LegalCopyText>
        </ComplianceTermsSectionFooter>
      </ComplianceTermsSectionContainer>
    </Container>
  );
}
